import options from "./options.js";
import singleText from "./singleText.js";
import multilineText from "./multilineText.js";
import upPicture from "./upPicture.js";
import time from "./time.js";
import roleMessage from "./roleMessage.js";

let formWidgetManager = {
    serverMap: {},
    clientMap: {},
    injectWidget(widget) {
        this.serverMap[widget.serverType] = widget;
        this.clientMap[widget.widgetName] = widget;
    }
};

formWidgetManager.injectWidget(options);
formWidgetManager.injectWidget(singleText);
formWidgetManager.injectWidget(multilineText);
formWidgetManager.injectWidget(upPicture);
formWidgetManager.injectWidget(time);
formWidgetManager.injectWidget(roleMessage);

export default formWidgetManager;
